import React from 'react';

import { formatCurrency } from '../../../../../../helpers/currencyMask';

export default function Distribution({ amounts, sum }) {
  if (sum === '-') {
    return sum;
  }

  return (
    <div className="flex flex-col">
      {amounts.map((amount) => (
        <span>${formatCurrency(amount)}</span>
      ))}
    </div>
  );
}
